/* Content data: team profiles + blog articles. Spanish primary; English fallback. */

export const TEAM = [
  {
    id: "dr-carlos",
    photo: "/img/team/therapist_1_quiro_fisio.png",
    name: "Fisioterapeuta Omar Aguilera",
    role: "Fisioterapeuta y Quiropráctico",
    yearsExperience: 12,
    license: "",
    bio_es:
      "Licenciado en Fisioterapia con maestría en Quiropráctica clínica y certificación internacional en Punción Seca y Terapia Manual. Con más de 12 años atendiendo a deportistas, oficinistas y adultos mayores, el Dr. Carlos se especializa en devolver la movilidad a pacientes con ciática, hernias discales, lesiones deportivas y síndromes posturales.",
    bio_en:
      "Physical Therapist with a master's in clinical Chiropractic and international certifications in Dry Needling and Manual Therapy. With 12+ years treating athletes, office workers and seniors, Dr. Carlos focuses on restoring mobility for patients with sciatica, disc hernias, sport injuries and postural syndromes.",
    specialties_es: [
      "Terapia física Pachuca",
      "Quiropráctica clínica (ajustes Diversified)",
      "Masaje deportivo y masaje de descarga",
      "Rehabilitación post-quirúrgica",
      "Vendaje neuromuscular (kinesiotape)",
      "Punción seca y terapia neural",
    ],
    specialties_en: [
      "Physical therapy",
      "Clinical chiropractic (Diversified technique)",
      "Sport and recovery massage",
      "Post-surgical rehab",
      "Kinesiotaping",
      "Dry needling and neural therapy",
    ],
    education_es: [
      "Licenciatura en Fisioterapia — UAEH",
      "Maestría en Quiropráctica Clínica",
      "Certificación internacional en Punción Seca",
      "Diplomado en Terapia Manual y Manipulación Articular",
    ],
    accent: "green",
  },
  {
    id: "dra-lucia",
    photo: "/img/team/therapist_2_medicina_funcional.png",
    name: "Lic. Ismael Mendoza",
    role: "Médico Funcional · Ozonoterapia · Terapias Alternativas",
    yearsExperience: 14,
    license: "",
    bio_es:
      "Médico cirujano con especialidad en Medicina Funcional y Ozonoterapia, certificado por la Sociedad Científica de Ozonoterapia. Combina diagnóstico clínico avanzado con herbolaria, adaptógenos, mesoterapia y terapia neural para tratar fatiga crónica, ansiedad, dolor sistémico, problemas digestivos y enfermedades autoinmunes desde la raíz.",
    bio_en:
      "MD with specialties in Functional Medicine and Ozone Therapy, certified by the Scientific Society of Ozonotherapy. Combines advanced clinical diagnosis with herbalism, adaptogens, mesotherapy and neural therapy to address chronic fatigue, anxiety, systemic pain, digestive issues and autoimmune conditions at their root.",
    specialties_es: [
      "Medicina funcional y diagnóstico integrativo",
      "Ozonoterapia (auto-hemoterapia, insuflación)",
      "Mesoterapia corporal",
      "Terapia neural",
      "Herbolaria clínica y adaptógenos",
      "Reflexología y técnicas energéticas",
    ],
    specialties_en: [
      "Functional medicine and integrative diagnosis",
      "Ozone therapy (auto-hemotherapy, insufflation)",
      "Body mesotherapy",
      "Neural therapy",
      "Clinical herbalism and adaptogens",
      "Reflexology and energetic techniques",
    ],
    education_es: [
      "Médico Cirujano — UNAM",
      "Especialidad en Medicina Funcional — IFM",
      "Certificación en Ozonoterapia Clínica",
      "Diplomado en Herbolaria y Fitoterapia",
    ],
    accent: "emerald",
  },
  {
    id: "lic-sofia",
    photo: "/img/team/therapist_3_estetica.png",
    name: "Lic. Anabel Mendoza",
    role: "Cosmiatra · Estética facial y corporal",
    yearsExperience: 9,
    license: "",
    bio_es:
      "Cosmiatra profesional con formación en dermocosmética avanzada y mesoterapia facial. Crea protocolos personalizados antiedad, despigmentantes y para acné, combinando aparatología de última generación con masajes faciales esculpidos y lifting de pestañas. Su filosofía: una piel sana es la base de tu confianza.",
    bio_en:
      "Professional Cosmiatrist with advanced training in dermocosmetics and facial mesotherapy. Designs personalized anti-aging, depigmentation and acne protocols, combining cutting-edge devices with sculpting facial massage and lash lift. Her philosophy: healthy skin is the foundation of your confidence.",
    specialties_es: [
      "Faciales antiedad y efecto lifting",
      "Mesoterapia facial",
      "Tratamiento de acné y secuelas",
      "Despigmentantes y peeling químico",
      "Faciales hidratantes y para piel sensible",
      "Lifting de pestañas y diseño de cejas",
    ],
    specialties_en: [
      "Anti-aging and lifting facials",
      "Facial mesotherapy",
      "Acne and scar treatment",
      "Depigmentation and chemical peel",
      "Hydrating facials for sensitive skin",
      "Lash lift and brow design",
    ],
    education_es: [
      "Licenciatura en Cosmiatría",
      "Certificación en Mesoterapia Facial",
      "Especialización en Peeling Químico y Aparatología",
      "Master en Lifting de Pestañas y Diseño de Mirada",
    ],
    accent: "rose",
  },
];

export const BLOG_POSTS = [
  {
    id: "fisioterapia-quiropractica-pachuca",
    slug: "fisioterapia-quiropractica-pachuca",
    title:
      "Fisioterapia y quiropráctica en Pachuca: la guía completa para recuperar tu movilidad sin dolor",
    excerpt:
      "Qué es realmente la fisioterapia, en qué se diferencia del huesero, cómo te ayuda la quiropráctica clínica y cuáles son los padecimientos que más tratamos en Pachuca, Hidalgo.",
    cover: "/img/blog/blog_fisio_quiro.png",
    author: "Fisioterapeuta Omar Aguilera",
    authorId: "dr-carlos",
    date: "2026-04-15",
    readingTime: "9 min",
    tags: [
      "terapia fisica pachuca",
      "quiropractico",
      "huesero",
      "masaje deportivo",
      "masaje de descarga",
      "terapia deportiva",
    ],
    content: [
      {
        type: "intro",
        text:
          "Si vives en Pachuca y has buscado en Google \"terapia física Pachuca\", \"quiropráctico\" o \"huesero\", probablemente ya recorriste varias opciones sin saber qué te conviene. En este artículo aclaramos las diferencias entre cada disciplina, te explicamos cuándo acudir a una u otra y cuáles son los padecimientos que más tratamos en TERAFIQUIRO Wellness Center.",
      },
      {
        type: "h2",
        text: "¿Qué es la terapia física y qué la diferencia del 'huesero'?",
      },
      {
        type: "p",
        text:
          "La terapia física (o fisioterapia) es una disciplina clínica regulada y respaldada por evidencia científica que se enfoca en restaurar el movimiento, reducir el dolor y prevenir nuevas lesiones. Mientras que el 'huesero' tradicional aplica ajustes empíricos sin estudios diagnósticos, el fisioterapeuta clínico realiza una valoración integral (postura, fuerza, rango articular, marcha) y diseña un plan personalizado que combina técnicas manuales con tecnología (ultrasonido, láser, electroterapia) y ejercicio terapéutico.",
      },
      {
        type: "p",
        text:
          "En TERAFIQUIRO no creemos en \"crujidos mágicos\" aislados. Creemos en un proceso ordenado: diagnóstico → reducción del dolor → recuperación de movilidad → fortalecimiento → educación postural. Es la única forma de evitar recaídas.",
      },
      {
        type: "h2",
        text: "Quiropráctica clínica: cuándo sí es la respuesta",
      },
      {
        type: "p",
        text:
          "La quiropráctica clínica se enfoca en la columna vertebral y articulaciones periféricas. Mediante manipulaciones articulares precisas (técnica Diversified) liberamos bloqueos que generan dolor referido. Es altamente efectiva para:",
      },
      {
        type: "ul",
        items: [
          "Ciática y dolor lumbar crónico",
          "Dolor cervical, tortícolis y mareos cervicogénicos",
          "Migrañas y cefaleas tensionales",
          "Hernias discales lumbares y cervicales",
          "Síndrome de la articulación sacroilíaca",
          "Bloqueos costovertebrales que limitan la respiración",
          "Dolor de hombro con limitación articular",
        ],
      },
      {
        type: "p",
        text:
          "A diferencia del huesero tradicional, en una sesión quiropráctica clínica primero exploramos, palpamos, valoramos riesgos (osteoporosis, presión arterial, antecedentes) y solo entonces ajustamos. Es seguro, indoloro y la mayoría de pacientes siente alivio desde la primera sesión.",
      },
      {
        type: "h2",
        text: "Masaje deportivo y masaje de descarga: terapias para deportistas",
      },
      {
        type: "p",
        text:
          "El masaje de descarga es uno de los servicios estrella para corredores, triatletas, ciclistas, jugadores de pádel/tenis y gimnastas. Aplicamos presión profunda en cadenas musculares específicas para eliminar puntos gatillo, descargar tensión acumulada por entrenamientos intensos y acelerar la recuperación entre sesiones de alto rendimiento. Lo combinamos con vendaje neuromuscular (kinesiotape) para soporte sin restringir el movimiento.",
      },
      {
        type: "p",
        text:
          "Para lesiones deportivas activas (esguinces, tendinitis, rotura muscular leve) seguimos protocolos de rehabilitación específicos: en las primeras 72 horas crioterapia y láser, después termoterapia, propiocepción y fortalecimiento progresivo. Volver a competir más fuerte es nuestro KPI.",
      },
      {
        type: "h2",
        text: "Padecimientos más frecuentes en nuestro consultorio",
      },
      {
        type: "ul",
        items: [
          "Lumbalgia (dolor de espalda baja) por mala postura o cargar pesos",
          "Cervicalgia y dolor entre escápulas por uso prolongado de computadora",
          "Ciática verdadera (compresión del nervio ciático)",
          "Dolor de cadera y rodilla por desbalance pélvico o gonalgia",
          "Tendinitis de hombro, codo (epicondilitis) y muñeca (túnel carpiano)",
          "Hombro congelado (capsulitis adhesiva)",
          "Fascitis plantar y dolor de pie",
          "Lesiones deportivas: esguinces, desgarros y sobrecargas musculares",
          "Rehabilitación post-fractura y post-cirugía (ligamento cruzado, prótesis de cadera/rodilla)",
        ],
      },
      {
        type: "h2",
        text: "¿Cuántas sesiones necesito?",
      },
      {
        type: "p",
        text:
          "Depende totalmente del diagnóstico y el tiempo de evolución. Como referencia general: dolores agudos (menos de 2 semanas) suelen resolverse en 3 a 6 sesiones. Casos crónicos requieren entre 8 y 12 sesiones más mantenimiento mensual. Nunca te haremos firmar paquetes largos sin haber visto resultados primero — ese es nuestro compromiso.",
      },
      {
        type: "h2",
        text: "Cómo agendar tu primera valoración",
      },
      {
        type: "p",
        text:
          "Agenda en línea desde el calendario de la sección \"Fisioterapia y Quiropráctica\" o escríbenos a WhatsApp +52 771 214 1634. En tu primera visita realizamos valoración postural completa, exploración funcional, diagnóstico clínico y comenzamos tratamiento el mismo día. Recuerda traer estudios previos si los tienes.",
      },
    ],
  },
  {
    id: "medicina-funcional-ozonoterapia-estetica-pachuca",
    slug: "medicina-funcional-ozonoterapia-estetica-pachuca",
    title:
      "Medicina funcional, ozonoterapia y estética integrativa: el nuevo wellness en Pachuca",
    excerpt:
      "Por qué la medicina funcional está revolucionando la salud, qué es realmente la ozonoterapia, cómo funciona la mesoterapia y qué tratamientos faciales tienen evidencia real. Una guía honesta.",
    cover: "/img/blog/blog_funcional_estetica.png",
    author: "Lic. Ismael Mendoza",
    authorId: "dra-lucia",
    date: "2026-04-22",
    readingTime: "11 min",
    tags: [
      "medicina funcional",
      "ozonoterapia",
      "mesoterapia",
      "herbolaria",
      "adaptogenos",
      "tratamiento facial",
      "estetica pachuca",
    ],
    content: [
      {
        type: "intro",
        text:
          "Llevamos décadas tratando síntomas: pastilla para el dolor, antiácido para la gastritis, ansiolítico para el insomnio. La medicina funcional propone algo distinto: encontrar las causas reales (intestino permeable, inflamación crónica, déficits nutricionales, estrés oxidativo) y corregirlas. En este artículo verás cómo combinamos medicina funcional con ozonoterapia, mesoterapia, herbolaria, adaptógenos y estética integrativa para un wellness 360°.",
      },
      {
        type: "h2",
        text: "¿Qué es la medicina funcional?",
      },
      {
        type: "p",
        text:
          "La medicina funcional es un enfoque clínico que ve el cuerpo como un sistema interconectado. En lugar de centrarse solo en el órgano que duele, evalúa la nutrición, la microbiota intestinal, las hormonas, el sistema inmune y el estrés. Trabajamos con análisis avanzados (microbioma, micronutrientes, perfil hormonal, marcadores inflamatorios) para diseñar un plan personalizado de suplementación, alimentación, lifestyle y, cuando hace falta, intervenciones puntuales como ozonoterapia o terapia neural.",
      },
      {
        type: "p",
        text:
          "En TERAFIQUIRO trabajamos especialmente padecimientos crónicos: fatiga adrenal, hipotiroidismo subclínico, colon irritable, migrañas recurrentes, fibromialgia, ansiedad e insomnio, sobrepeso resistente y enfermedades autoinmunes en etapas tempranas.",
      },
      {
        type: "h2",
        text: "Ozonoterapia: oxígeno terapéutico con evidencia clínica",
      },
      {
        type: "p",
        text:
          "El ozono médico (O₃) es una mezcla gaseosa de oxígeno trivalente que, aplicado en dosis controladas, modula el sistema inmune, mejora la oxigenación tisular y reduce la inflamación. No es una moda — la ozonoterapia tiene más de 70 años de uso clínico y está reconocida en países como Alemania, Italia, Cuba y México. Algunas indicaciones clínicas:",
      },
      {
        type: "ul",
        items: [
          "Dolor articular y hernias discales (aplicación local intradiscal o paravertebral)",
          "Fatiga crónica y bajo rendimiento físico",
          "Infecciones recurrentes y apoyo inmunológico",
          "Heridas crónicas, úlceras y problemas circulatorios periféricos",
          "Migrañas resistentes a tratamiento convencional",
          "Detoxificación y soporte post-COVID prolongado",
        ],
      },
      {
        type: "h2",
        text: "Mesoterapia: micro-inyecciones inteligentes",
      },
      {
        type: "p",
        text:
          "La mesoterapia consiste en micro-inyecciones de medicamentos, vitaminas o ácido hialurónico directamente en la dermis o tejidos superficiales. Tiene dos grandes ramas:",
      },
      {
        type: "ul",
        items: [
          "Mesoterapia corporal: para reducir adiposidad localizada (cartucheras, abdomen, espalda baja), mejorar celulitis y aportar nutrientes en zonas de dolor articular.",
          "Mesoterapia facial: para hidratación profunda, luminosidad, atenuación de líneas finas, manchas y mejora de cicatrices de acné. Es excelente como mantenimiento antiedad sin pasar por cirugía.",
        ],
      },
      {
        type: "h2",
        text: "Terapia neural, herbolaria y adaptógenos",
      },
      {
        type: "p",
        text:
          "La terapia neural utiliza pequeñas inyecciones de procaína diluida en puntos clave del sistema nervioso autónomo para 'resetear' información dolorosa o disfuncional. Combinada con herbolaria clínica (cúrcuma, jengibre, boswellia, valeriana) y adaptógenos (ashwagandha, rhodiola, ginseng, reishi) potencia el efecto y reduce el uso crónico de fármacos. No reemplaza tu tratamiento médico, lo complementa de forma inteligente.",
      },
      {
        type: "h2",
        text: "Tratamientos faciales con evidencia real",
      },
      {
        type: "p",
        text:
          "En TERAFIQUIRO nuestra cosmiatra diseña protocolos personalizados con productos profesionales y aparatología validada. Los más solicitados:",
      },
      {
        type: "ul",
        items: [
          "Facial antiedad con efecto lifting (radiofrecuencia + masaje esculpido)",
          "Tratamiento para acné y secuelas (peeling químico controlado + LED)",
          "Despigmentante para manchas, melasma y daño solar",
          "Hidratación profunda para piel seca o sensible (mesoterapia facial)",
          "Lifting de pestañas con queratina y diseño de cejas",
        ],
      },
      {
        type: "p",
        text:
          "La clave: no prometemos milagros. Trabajamos con metas realistas, fotos antes/después documentadas y protocolos que respetan la barrera cutánea — para que tu piel se vea bien hoy y siga sana en 10 años.",
      },
      {
        type: "h2",
        text: "¿Cómo elijo el tratamiento adecuado?",
      },
      {
        type: "p",
        text:
          "Lo más inteligente es agendar primero una valoración de Medicina Funcional o de Estética según tu motivo principal. Ahí definimos qué combinación de tratamientos te conviene. No todos necesitan ozonoterapia, no todos necesitan mesoterapia. La buena medicina es la que se hace a tu medida.",
      },
      {
        type: "p",
        text:
          "Agenda tu valoración desde el calendario de \"Terapias Alternativas\" o \"Tratamientos Estéticos\" en este mismo sitio, o escríbenos por WhatsApp al +52 771 161 0609 (alternativas) o +52 771 129 0073 (estética). Estamos en Calle El Pípila 200, Col. Centro, Pachuca de Soto, Hidalgo.",
      },
    ],
  },
];
